import { atom } from "jotai";

import { clientConfigAtom } from "atoms/clientConfig";

import { paymentQuestionAtom } from "./questions";

export const isAcceptanceValidAtom = atom((get) => {
  const answeredQuestions = get(paymentQuestionAtom);
  const {
    speedyPayment,
  } = get(clientConfigAtom);

  const validations = {
    questionsSelected: speedyPayment?.questions?.every((question) => typeof answeredQuestions[question] === "boolean"),
  };

  return Object.values(validations).every((validation) => validation);
});
